import { IconMoneybag, IconBookFilled, IconUsersGroup, IconClock } from "@tabler/icons-react"
import { icon } from "../functions/icons"
import { Badge } from "../atoms/badges"
import { IconText } from "./courseComp"
import { Trend } from "../atoms/trend"
import { SkeletonCourseTableRow } from "../atoms/skeletonloaders"
import { IconAtom } from "../atoms/iconAtom"
import { HorizontalLayout } from "./layout"
import { StandardComp } from "../atoms/standardComp"
import { margin, padding } from "polished"
import { TitleAction } from "../molecule/TitleAction"
import { DropdownButton, StandardButton } from "../atoms/buttons"
import { HeaderTitle } from "../molecule/headerTitle"
import { useContext, useEffect, useState } from "react"
import { formatDistanceToNow } from 'date-fns';
import { nl } from 'date-fns/locale';
import { PageContext, UserContext } from "../App";

export function CourseTableComp({ courses = [], courseOpen, loading = false, margin, headers= ["Cursus", "Lengte", "Aantal lessen", "Status"] }) {
    
    return (
        <div role="course-table" className="courses-table standard-small-margin-top standard-rounded" style={{ textAlign: "left", borderCollapse: 'collapse', margin:margin }}>
            <div className="courses-table-head">
                { headers.map((header,index) => {
                    return(<p style={{ width:(index == 0)&&"50%", alignItems: "center", textAlign:index == 0 ? "left" : "center", }} className="standard-padding semi-bold">{header}</p>)
                })}
            </div>
            <div className="courses-table-body">
                { loading ? <>
                    { [...Array(3)].map((_, idx) => {
                        return (
                            <SkeletonCourseTableRow key={idx}/>
                        )
                    })}
                </> :
                <>   
                    { courses.map((course) => {
                        return (
                            <CourseTableRow key={course.id_course} onClick={courseOpen} course={course}/>
                        )
                    })}
                </>
                }
            </div>
        </div>
    )
}

export function DashboardTable({ data, GoToReport }) {
  const hasData = Array.isArray(data) && data.length > 0;
  const itemsPerPage = 10;
  const [page, setPage] = useState(0);
  const totalPages = Math.ceil((data?.length || 0) / itemsPerPage);
  const paginatedData = hasData ? data.slice(page * itemsPerPage, (page + 1) * itemsPerPage) : [];
 
  return (
    <StandardComp
      style={{ padding: 0, overflow: "hidden", cursor: "unset", margin: "1rem 0 0 0", minHeight: 600, display: "flex", flexDirection: "column" }}
      editClass="standard-margin"
      content={
        <>
          <div style={{ flex: 1, overflowY: "auto" }}>
           <table className="suggest-table__table" style={{ border: 0, width: "100%" }}>
              <thead>
                <tr style={{ display: "flex", justifyContent: "space-between", marginRight: "1rem", }}>
                  <th className="suggest-table__th" style={{ flex: 1 }}>Cursus</th>
                  <th className="suggest-table__th" style={{ flex: 1, textAlign: "right" }}>Aantal deelnemers</th>
                </tr>
              </thead>
              <tbody>
                {hasData
                  ? paginatedData.map(({ id_course, title, user_count }) => (
                      <tr className="dashboard-table" onClick={() => GoToReport(id_course)} key={id_course} style={{ display: "flex", justifyContent: "space-between", margin: "0 1rem", padding: "0",}}>
                        <td className="suggest-table__td" style={{ flex: 1 }}>{title}</td>
                        <td className="suggest-table__td" style={{ flex: 1, textAlign: "right" }}>{user_count}</td>
                      </tr>
                    ))
                  : (
                    <tr>
                      <td colSpan={2} style={{ textAlign: "center", padding: "2rem", fontStyle: "italic" }}>
                        Geen gegevens beschikbaar
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>
          {hasData && data.length > itemsPerPage && (
            <div style={{ borderTop: "1px solid #eee" }}>
              <HorizontalLayout className="standard-padding center" style={{ width: "100%", justifyContent: "center", padding: "0.75rem 0" }} >
                <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                  <StandardButton
                    className={page === 0 ? "disabled-btn" : ""}
                    title=""
                    arrow="left"
                    onClick={() => setPage(p => Math.max(p - 1, 0))}
                    isDisabled={page === 0}
                    size="small"
                  />
                  <span className="standard-text-color-light" style={{ fontSize: "0.9rem" }}>
                    {page + 1} / {totalPages}
                  </span>
                  <StandardButton
                    style={{ marginLeft: "0" }}
                    className={page >= totalPages - 1 ? "disabled-btn" : ""}
                    title=""
                    arrow="right"
                    onClick={() => setPage(p => Math.min(p + 1, totalPages - 1))}
                    isDisabled={page >= totalPages - 1}
                    size="small"
                  />
                </div>
              </HorizontalLayout>
            </div>
          )}
        </>
      }
    />
  );
}


export function SuggestCourseTableComp({ courses, title }) {
    const [selectedCourseByUser, setSelectedCourseByUser] = useState({});
    const [selectedGlobalCourseId, setSelectedGlobalCourseId] = useState(courses.courses);
    const [page, setPage] = useState(0);
    const itemsPerPage = 10;
    const userInformation = useContext(UserContext);



  useEffect(() => {
    if(courses.length > 0 && !selectedGlobalCourseId) {
      setSelectedGlobalCourseId(courses[0].courses[0]?.course_id || null);
    }
  }, [courses]);       


  const formatRelativeTime = (dateString) => {
    if (!dateString) return "Geen activiteit";
    let res = formatDistanceToNow(new Date(dateString), { addSuffix: true, locale: nl });
    return res.startsWith("ongeveer ") ? res.replace("ongeveer ", "") : res;
  };

  const formatDate = (dateString) =>
    !dateString ? "Geen activiteit" : new Date(dateString).toLocaleString("nl-NL");

  const allCourses = [];
  courses.forEach(user =>
    user.courses?.forEach(course => {
      if (!allCourses.find(c => c.course_id === course.course_id)) allCourses.push(course);
    })
  );

  const handleGlobalCourseSelect = (courseId) => {
      setSelectedGlobalCourseId(courseId);
      setPage(0);
      const newSelected = {};
      courses.forEach(user => {
        if (user.courses?.some(c => c.course_id === courseId)) newSelected[user.user_id] = courseId;
      });
      setSelectedCourseByUser(newSelected);
    };

    const selectedGlobalCourseName = allCourses.find(c => c.course_id === selectedGlobalCourseId)?.course_name || null;
    const filteredUsers = selectedGlobalCourseId
      ? courses.filter(user => user.courses?.some(c => c.course_id === selectedGlobalCourseId))
      : courses;

    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
    const paginatedUsers = filteredUsers.slice(page * itemsPerPage, (page + 1) * itemsPerPage);

    const navigationContext = useContext(PageContext);
    const employeeText = userInformation?.org_settings?.employee_text || "Werknemers";
  return (
    <>
      <HorizontalLayout className="standard-padding" style={{ width: "auto", display: "flex", alignItems: "center", paddingBottom: "0",}}>
        <HeaderTitle title={title || "Statiestieken"} />
        <DropdownButton
          content={selectedGlobalCourseName || "Selecteer cursus"}
          dropdown={allCourses.map(course => ({ id: course.course_id, content: course.course_name }))}
          optionSelected={handleGlobalCourseSelect}
          classButton="dropdown-course-button"
          classContent="dropdown-course-menu"
          width="100%"
          dropdownStyle={{ top: "0", right: "0", left: "unset", }}
        />
      </HorizontalLayout>

      <StandardComp
        style={{ padding: 0, cursor: "unset" }}
        editClass="standard-margin"
        content={
          <>
          <table className="suggest-table__table">
            <thead>
              <tr>
                {[ employeeText, "Gestart op", "Voortgang / Afgerond", "Laatste activiteit"].map(th => (
                  <th key={th} className="suggest-table__th">{th}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {courses.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center", padding: "2rem", fontStyle: "italic" }}>
                    Selecteer een cursus om de statistieken te zien
                  </td>
                </tr>
              ) : (
                paginatedUsers.map(user => {
                  const avatarUrl = user.avatar || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.name)}&background=random&color=fff&format=svg`;
                  const coursesList = user.courses || [];
                  const selectedCourse = selectedGlobalCourseId ? coursesList.find(c => c.course_id === selectedGlobalCourseId) : coursesList.find(c => c.course_id === selectedCourseByUser[user.user_id]) || coursesList[0] || null;
                  const progressOrFinish = selectedCourse?.finish_time ? formatDate(selectedCourse.finish_time) : `${selectedCourse?.progress || 0}%`;

                  return (
                    <tr key={user.user_id} onClick={() => navigationContext.handleNavigation({...navigationContext.sidebar,userId:user.user_id, navigation: 7, courseID:selectedGlobalCourseId, back_page:11})} className="suggest-table__row">
                      <td className="suggest-table__td">
                        <div className="suggest-table__avatar-wrapper" >
                          <div className="suggest-table__avatar" style={{ backgroundImage: `url("${avatarUrl}")` }} />
                          <span className="suggest-table__name">{user.name}</span>
                        </div>
                      </td>
                      <td className="suggest-table__td">{selectedCourse?.start_time ? formatDate(selectedCourse.start_time) : "Niet gestart"}</td>
                      <td className="suggest-table__td">
                        {selectedCourse?.finish_time ? (
                          <span>Afgerond op: {progressOrFinish}</span>
                        ) : (
                          <div className="suggest-table__progress-wrapper">
                            <div className="suggest-table__progress-bar">
                              <div className="suggest-table__progress-fill" style={{ width: progressOrFinish }} />
                            </div>
                            <p className="suggest-table__progress-text">{progressOrFinish}</p>
                          </div>
                        )}
                      </td>
                      <td className="suggest-table__td suggest-table__activity-text">
                        {selectedCourse?.last_activity ? formatRelativeTime(selectedCourse.last_activity) : "Geen activiteit"}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
            {filteredUsers.length > itemsPerPage && (
              <div style={{ borderTop: "1px solid #eee"}}>
                <HorizontalLayout className="standard-padding center" style={{ width: "100%", justifyContent: "center", padding: "0.75rem 0" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                    <StandardButton
                      className={page === 0 ? "disabled-btn" : ""}
                      title=""
                      arrow="left"
                      onClick={() => setPage(p => Math.max(p - 1, 0))}
                      isDisabled={page === 0}
                      size="small"
                    />
                    <span className="standard-text-color-light" style={{ fontSize: "0.9rem" }}>
                      {page + 1} / {totalPages}
                    </span>
                    <StandardButton
                      style={{ marginLeft: "0" }}
                      className={page >= totalPages - 1 ? "disabled-btn" : ""}
                      title=""
                      arrow="right"
                      onClick={() => setPage(p => Math.min(p + 1, totalPages - 1))}
                      isDisabled={page >= totalPages - 1}
                      size="small"
                    />
                  </div>
                </HorizontalLayout>
              </div>
            )}
           </>
        }
      />
    </>
  );
}


export function CourseTableRow({ course={}, onClick }) {
   function getCourseStatus(course) {
    const progress = parseInt(course.progress, 10);
    const published = course.published;
    const active = course.active;

    const statusMap = [
      { check: () => published === 0, status: "notPublished" },
      { check: () => published === 2, status: "inactive" },
      { check: () => published === 1 && progress === 0, status: "published" },
      { check: () => published === 1 && progress > 0 && progress < 100, status: "inProgress" },
      { check: () => published === 1 && progress === 100 && active === 2, status: "finished" },
      { check: () => published === 1 && progress === 100, status: "published" } 
    ];

    const found = statusMap.find(entry => entry.check());
    return found ? found.status : "unknown";
  }
  const avatar = course.image_url || `https://ui-avatars.com/api/?name=${course.title}`
    return (
        <div data-testid={"course-table-row"} onClick={() => onClick(course)} className="courses-table-row">
            <div className="courses-table-information">
                <img src={avatar} alt={course.title}/>
                <div>
                    <p className="course-info">{ course.title }</p>
                    <p className="course-info">{ course.description }</p>
                </div>
            </div>
            <div className="course-info center">
                { course.moduleCount * 3 }m
            </div>
            <div className="course-info center">
                { course.lessonCount }
            </div>
            <div className="course-info center">
                 <CourseStatusLabel status={getCourseStatus(course)} />
            </div>
        </div>
    )
}

export function SimpleCourseTableRow({ course={}, onClick, buttonVisible = false, style }) {
  const avatar = course.image_url || `https://ui-avatars.com/api/?name=${course.title}`
    return (
        <div data-testid={"course-table-row"} onClick={() => onClick(course)} className="courses-table-row" style={style}>
            <div className="courses-table-information">
                <img src={avatar} alt={course.title}/>
                <div>
                    <p className="course-info">{ course.title }</p>
                </div>
            </div>
            { buttonVisible &&
            <div>
                <IconText
                click={(e) => { e.stopPropagation(); alert("dot")}}
                icon2={'x'}
                backgroundColor="var(--error-100)"
                iconColor={"var(--error-600)"}
                tooltipBackground={"var(--error-600)"}
                tooltipLocation={"left"}
                />
            </div>
            }
        </div>
    )
}

export function CourseStatusLabel({ status }) {
    const statusMap = {
        "notPublished": { text: "Bijwerken", color: "--not-published" },
        "published": { text: "Gepubliceerd", color: "--published" },
        "inactive": { text: "Inactief", color: "--error-500" },
        "inProgress": { text: "Bezig", color: "--in-progress" },
        "finished": { text: "Afgerond", color: "--finished" },
    };

    const { text, color } = statusMap[status] || { text: "Onbekend", color: "#6b7280" };

    return (
        <span
            style={{
                backgroundColor: `var(${color})`,
                color: "white",
                padding: "0.25rem 0.5rem",
                borderRadius: "0.375rem",
                fontWeight: "500",
                fontSize: "0.875rem",
                textAlign: "center",
                display: "inline-block",
            }}
        >
            {text}
        </span>
    );
}
